"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Surface = undefined;

var _legacy = require("./legacy");

Object.keys(_legacy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _legacy[key];
    }
  });
});

var _glReact = require("gl-react");

var _GLViewDOM = require("./GLViewDOM");

var _GLViewDOM2 = _interopRequireDefault(_GLViewDOM);

var _ImageTextureLoader = require("./ImageTextureLoader");

var _ImageTextureLoader2 = _interopRequireDefault(_ImageTextureLoader);

var _CanvasTextureLoader = require("./CanvasTextureLoader");

var _CanvasTextureLoader2 = _interopRequireDefault(_CanvasTextureLoader);

var _VideoTextureLoader = require("./VideoTextureLoader");

var _VideoTextureLoader2 = _interopRequireDefault(_VideoTextureLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_glReact.TextureLoaders.add(_ImageTextureLoader2.default);

_glReact.TextureLoaders.add(_CanvasTextureLoader2.default);
_glReact.TextureLoaders.add(_VideoTextureLoader2.default);

var getPixelSize = function getPixelSize(_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$pixelRatio = _ref.pixelRatio,
      pixelRatio = _ref$pixelRatio === undefined ? Number(window.devicePixelRatio || 1) : _ref$pixelRatio;
  return [pixelRatio * width, pixelRatio * height];
};

var RenderLessElement = "span";

var mapRenderableContent = function mapRenderableContent(el) {
  return el instanceof Element ? el.firstElementChild : null;
};

var Surface = exports.Surface = (0, _glReact.createSurface)({
  GLView: _GLViewDOM2.default,
  getPixelSize: getPixelSize,
  RenderLessElement: RenderLessElement,
  mapRenderableContent: mapRenderableContent
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react-dom/lib/index.js
// module id = 224
// module chunks = 0